import * as React from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

export default function ClassificationBanner({ isCui }) {
  const label = isCui ? 'CUI' : 'UNCLASSIFIED';

  return (
    <Box
      role="status"
      aria-label={`${label} classification banner`}
      sx={{
        width: '100%',
        px: 2,
        py: 1,
        borderRadius: 1,
        bgcolor: isCui ? 'warning.main' : 'success.dark',
        color: isCui ? 'warning.contrastText' : 'common.white',
        textAlign: 'center',
        boxShadow: 1,
      }}
    >
      <Typography
        component="div"
        variant="h6"
        sx={{ fontWeight: 900, letterSpacing: '0.16em', lineHeight: 1.35 }}
      >
        {label}
      </Typography>
    </Box>
  );
}
